function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "fire1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 44.507812 0 L 255.9375 0 L 255.9375 300 L 44.507812 300 Z M 44.507812 0 "
})));

function SvgFireIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    viewBox: "0 0 300 299.999988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "fireicon1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fire1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(95.689392%,45.098877%,12.159729%)",
      fillOpacity: 1
    },
    d: "M 70.960938 90.625 C 83.289062 104.140625 89.214844 123.089844 92.726562 143.410156 C 95.175781 121.628906 105.1875 101.796875 111.019531 80.085938 C 117.207031 57.039062 119.199219 27.535156 101.382812 0 C 150.746094 24.621094 176.535156 84.796875 182.988281 120.675781 C 183.445312 97.335938 195.699219 62.425781 222.125 45.609375 C 211.988281 70.515625 217.058594 98.046875 227.179688 122.058594 C 233.683594 137.488281 241.949219 151.789062 247.984375 167.78125 C 265.648438 214.554688 256.714844 267.558594 204.246094 285.570312 C 213.984375 273.082031 217.890625 250.753906 214.722656 233.941406 C 206.785156 256.777344 183.855469 269.015625 169.988281 271.503906 C 199.101562 226.300781 176.597656 168.273438 152.980469 140.578125 C 165.953125 198.621094 77.164062 228.171875 115.960938 300.007812 C 51.761719 276.414062 40.101562 230.109375 45.773438 193.8125 C 51.910156 154.550781 76.8125 117.078125 70.960938 90.625 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/FireIcon.8fc32dab.svg";
export { ForwardRef as ReactComponent };